/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import NBCTruncate from 'components/nbc-truncate';
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

const isMobile = window.matchMedia('screen and (max-width: 767px)').matches;
const sponsoredArticleIndex = 4;

/**
 * NativeSponsor component.
 */
export default class NativeSponsor extends Component {
  static propTypes = {
    includeSponsored: PropTypes.bool,
  };

  static defaultProps = {
    includeSponsored: false,
  };

  // eslint-disable-next-line consistent-return
  static renderArticle(article) {
    const {
      i18n: {
        __,
      },
    } = wp;

    // Handle a taboola slot.
    const {
      thumbnail_url: thumbnailUrl, // eslint-disable-line camelcase
      link,
      title,
      presented_by: presentedBy, // eslint-disable-line camelcase
    } = article;

    const sanitizedTitle = parse(DOMPurify.sanitize(title));

    return (
      <Fragment>
        <div className="post__image__wrap">
          {thumbnailUrl && 0 !== thumbnailUrl.length && (
            <a href={link}>
              <img
                className="post__image"
                src={`${thumbnailUrl}&resize=185%2C104`}
                alt={sanitizedTitle}
              />
            </a>
          )}
        </div>
        <div className="post__content">
          <h4 className="post__sponsor">{__('Sponsored', 'nbc')}</h4>
          <div className="post__title">
            <a href={link}>
              <NBCTruncate
                aria-label="post title"
                ellipsis="true"
                maxlines="3"
                maxlinesmobile="3"
                readmore=""
                text={sanitizedTitle}
              />
            </a>
          </div>
          {'' !== presentedBy && (
            <div className="post__presented_by">
              {parse(DOMPurify.sanitize(presentedBy))}
            </div>
          )}
        </div>
      </Fragment>
    );
  }

  state = {
    articles: false,
  };

  componentDidMount() {
    if (isMobile) {
      this.fetchArticles();
    }
  }

  fetchArticles() {
    const {
      props: {
        includeSponsored,
      },
    } = this;

    const { apiFetch } = wp;

    /*
      {to test sponsor, use '/wp-content/themes/nbc-station/static/top-stories-sponsor-test.json'}
      {add following url query in browser to simulate taboola: '?taboola_sim_domain=nbcnewyork.com'}
    */
    let url = '/wp-content/themes/nbc-station/static/top-stories-sponsor-test.json';
    let path = '/nbc/v1/top-stories';
    let appendParam;

    const {
      dataLayer: {
        section = '',
        sponsored = false,
      } = {},
    } = nbc;

    if (includeSponsored && ! sponsored) {
      appendParam = `?include_sponsored=1&section=${section}`;
    } else {
      appendParam = `?section=${section}`;
    }

    url = `${url}${appendParam}`;
    path = `${path}${appendParam}`;

    if ('local' === nbc.env || 'develop' === nbc.env) {
      apiFetch({
        url,
      })
        .then((articles) => {
          this.setState({ articles });
        });
    } else {
      apiFetch({
        path,
      })
        .then((articles) => {
          this.setState({ articles });
        });
    }
  }

  render() {
    const { articles } = this.state;

    if (! articles || articles.length < sponsoredArticleIndex + 1) {
      return null;
    }

    const sponsoredArticle = articles[sponsoredArticleIndex];

    if ('sponsored' === sponsoredArticle.type) {
      return (
        <Fragment>
          {NativeSponsor.renderArticle(sponsoredArticle)}
        </Fragment>
      );
    }

    return null;
  }
}
